export default __webpack_public_path__ + "static/media/254-ppman.d4e56d0b.pdf";